import React from "react";
import { Form as ReactAriaForm } from "react-aria-components";
import clsx from "clsx";

import Heading from "../heading";

import styles from "./form.module.css";

type FormProps =
  | {
      headingText?: string;
      type?: "inline";
      children: React.ReactNode;
      className?: string;
      action?: string;
      button: React.ReactNode;
      onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
      display?: {
        align: "center" | "left";
      };
    }
  | {
      headingText: string;
      type: "page";
      children: React.ReactNode;
      className?: string;
      action?: string;
      button: React.ReactNode;
      onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
    };

function Form(props: FormProps) {
  const {
    type = "inline",
    children,
    action,
    className = "",
    button,
    headingText,
    onSubmit,
  } = props;
  const heading = headingText ? (
    <Heading level="2" text={headingText}></Heading>
  ) : null;
  const content =
    type === "inline" ? (
      <>
        {heading}
        {children}
        <div className={styles.submitButton}>{button}</div>
      </>
    ) : (
      <>
        <div className={styles.formElements}>
          {children}
          <div className={styles.pageSubmit}>{button}</div>
        </div>
      </>
    );

  return (
    <ReactAriaForm
      onSubmit={onSubmit}
      action={action}
      className={clsx(styles.form, className, {
        [styles.page]: type === "page",
        [styles.centered]:
          "display" in props && props.display?.align === "center",
      })}
    >
      {content}
    </ReactAriaForm>
  );
}

export default Form;
